import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import RichTextContent from './RichTextContent';
import './TextExpandable.css';
import './RichText.css';

const RichTextExpandable = ({ value = '', clamp = 6, className = '' }) => {
  const [open, setOpen] = useState(false);
  const [overflow, setOverflow] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    setOverflow(ref.current.scrollHeight > ref.current.clientHeight + 1);
  }, [value, clamp]);

  return (
    <div
      className={`gm-text-expand gm-rich-text-expand ${className}`.trim()}
      style={{ '--gm-clamp': clamp }}
    >
      <RichTextContent
        ref={ref}
        value={value}
        className={`gm-text-expand__text ${open ? 'gm-text-expand__text--open' : ''}`}
      />
      {(overflow || open) && (
        <button
          type="button"
          className="gm-text-expand__more"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            setOpen((current) => !current);
          }}
        >
          {open ? 'Mostrar menos' : 'Ler mais'}
        </button>
      )}
    </div>
  );
};

RichTextExpandable.propTypes = {
  value: PropTypes.string,
  clamp: PropTypes.number,
  className: PropTypes.string,
};

export default RichTextExpandable;

